const env = process.env.ENV || 'development';
// console.log(`ENV: ${env}`);

const config = {
  development: {
    // Emulator URL (with `npm run emulators:local` in rapidhire-backend). The project/region come
    // from .firebaserc's default project (d-ulti-tacq-rapidhire-cb75), which functions/index.ts
    // maps to us-east4 — NOT hire-humanly-dev/us-central1.
    apiPath: 'http://127.0.0.1:5001/d-ulti-tacq-rapidhire-cb75/us-east4/',
    // Deployed dev functions host — decommissioned, every function 404s. Kept for reference only.
    // apiPath: 'https://us-central1-hire-humanly-dev.cloudfunctions.net/',
    basePath: 'http://localhost:3001/',
    baseHost: 'localhost:3001',
    env,
    chattrbotJs: 'http://localhost:1701/chat.bundle.js',
    newApiPath: 'http://127.0.0.1:3333',
    feedApiPath: 'http://127.0.0.1:3333',
    candidatePortalPath: 'http://localhost:3001',
    // apiPath: 'https://us-central1-hire-humanly.cloudfunctions.net/',
    // basePath: 'https://jobs.chattr.ai/',
    // baseHost: 'chattr.jobs',
    // env,
    // chattrbotJs: `https://bot.chattr.ai/chat.js`,
    // newApiPath: 'https://api.chattr.ai',
    // candidatePortalPath: 'https://candidate.chattr.ai',
  },
  // USE THE CONFIG BELOW IF TESTING LOCALLY WITH BROWSERSTACK
  // development: {
  //   apiPath: "https://us-central1-hire-humanly-dev.cloudfunctions.net/",
  //   basePath: "http://bs-local.com:3001/",
  //   baseHost: "bs-local.com:3001",
  //   env: env,
  //   chattrbotJs: "http://bs-local.com:1701/chat.js",
  //   newApiPath: "http://bs-local.com:3333",
  //   candidatePortalPath: "http://bs-local.com:3001",
  // },
  staging: {
    apiPath: 'https://us-central1-hire-humanly-dev.cloudfunctions.net/',
    basePath: 'https://jobs-dev.chattr.ai/',
    baseHost: 'dev.chattr.jobs',
    env,
    chattrbotJs: `https://bot-dev.chattr.ai/chat.min.js`,
    newApiPath: 'https://api-dev.chattr.ai',
    feedApiPath: 'https://api-dev.chattr.ai',
    candidatePortalPath: 'https://candidate-dev.chattr.ai',
  },
  'staging-uat': {
    apiPath: 'https://us-central1-chattr-uat.cloudfunctions.net/',
    basePath: 'https://jobs-uat.chattr.ai/',
    baseHost: 'uat.chattr.jobs',
    env,
    chattrbotJs: `https://bot-uat.chattr.ai/chat.min.js`,
    newApiPath: 'https://api-uat.chattr.ai',
    feedApiPath: 'https://api-uat.chattr.ai',
    candidatePortalPath: 'https://candidate-uat.chattr.ai',
  },
  prodstaging: {
    apiPath: 'https://us-central1-hire-humanly.cloudfunctions.net/',
    basePath: 'https://jobs-staging.chattr.ai/',
    baseHost: 'chattr.jobs',
    env,
    chattrbotJs: `https://bot-staging.chattr.ai/chat.min.js`,
    newApiPath: 'https://api-staging.chattr.ai',
    feedApiPath: 'https://api-staging.chattr.ai',
    candidatePortalPath: 'https://candidate-staging.chattr.ai',
  },
  production: {
    apiPath: 'https://us-central1-hire-humanly.cloudfunctions.net/',
    basePath: 'https://jobs.chattr.ai/',
    baseHost: 'chattr.jobs',
    env,
    chattrbotJs: `https://bot.chattr.ai/chat.min.js`,
    newApiPath: 'https://api.chattr.ai',
    feedApiPath: 'https://api.rapidhire.ukg.net',
    candidatePortalPath: 'https://candidate.chattr.ai',
  },
  // Use when app is hosted in UKG Project
  // Using env vars is an easier pattern to manage in UKG ecosystem
  ukg: {
    apiPath:
      process.env.BACKEND_FUNCTIONS_URL ||
      'https://us-central1-hire-humanly-dev.cloudfunctions.net/',
    basePath: process.env.BASE_URL,
    baseHost: process.env.BASE_HOST || 'dev.chattr.jobs',
    env,
    chattrbotJs: process.env.CHATBOT_JS_URL || 'https://bot-dev.chattr.ai/chat.min.js',
    newApiPath: process.env.API_BACKEND_URL || 'https://rapidhire-api.pro.ukg.dev',
    feedApiPath: process.env.API_BACKEND_URL || 'https://rapidhire-api.pro.ukg.dev',
    candidatePortalPath: process.env.CANDIDATE_PORTAL_URL || 'https://candidate-dev.chattr.ai',
  },
}[env];

/*
  PS-927191 — anon endpoint cutover, read-only phase.

  When true, the endpoints ported out of the public ep-* Cloud Functions are called on the API
  (`${newApiPath}/candidate/v1/<name>`) instead of the function host (`${apiPath}<name>`). Same request
  body, same response envelope — only the host changes.

  The decision is NOT config: it is the LaunchDarkly flag
  `enable-rapid-hire-anon-cutover-read-only`, resolved at runtime through
  helpers/anonCutover.js -> helpers/featureFlags.js (PS-1020306). Read it from the seam, never
  from here. Server-rendered pages inject the resolved boolean into the `config` page prop
  (as `anonCutoverReadOnly`) for client-side callers.

  Local testing: `newApiPath` already points at the local API (127.0.0.1:3333) — start it with
  `npm start` in rapidhire-backend/api — then flip the flag in that API's LaunchDarkly
  environment (or stub helpers/featureFlags.js). To compare a ported route against the original
  function, also switch `apiPath` above to the emulator URL so both read the same local
  Firestore.
*/

// console.log(`Config in Config: ${JSON.stringify(config)}`);
module.exports = config;
